/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".menu-sidenav[_ngcontent-%COMP%]{width:200px;left:0}.menu-sidenav[_ngcontent-%COMP%]   .sidenav-option[_ngcontent-%COMP%]{text-align:left;padding:12px}.menu-sidenav[_ngcontent-%COMP%]   .sidenav-option[_ngcontent-%COMP%]:hover{cursor:pointer;background:#d3d3d3;color:#000!important}.menu-sidenav[_ngcontent-%COMP%]   .sidenav-option.active[_ngcontent-%COMP%]{opacity:1;background:#d3d3d3;color:#8b0000!important}.icon[_ngcontent-%COMP%]{vertical-align:bottom}.backdrop[_ngcontent-%COMP%]{z-index:1000;overflow:hidden;position:fixed;left:0;top:0;opacity:25%;background-color:#000;width:0%;height:100%}.sidenav[_ngcontent-%COMP%]{z-index:1000;display:block;overflow:hidden;position:fixed;left:-200px;top:0;background-color:#fff;width:200px;height:100%}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/components/sidenav/sidenav.component.scss.shim.ngstyle.js.pre-build-optimizer.js